import { render, staticRenderFns } from "./BestPractices.vue?vue&type=template&id=4a340712&scoped=true&"
import script from "./BestPractices.vue?vue&type=script&lang=ts&"
export * from "./BestPractices.vue?vue&type=script&lang=ts&"
import style0 from "./BestPractices.vue?vue&type=style&index=0&id=4a340712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a340712",
  null
  
)

export default component.exports